// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__3-8TY","dragIcon":"SortableItem_dragIcon__1yWjW","disabled":"SortableItem_disabled__HVoRX"};